module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/store_images/5_1eb0e44175296ac3f7efa2cd363b235b.png";